import { render, staticRenderFns } from "./CompaniesBlock.vue?vue&type=template&id=1a7e45c5&"
import script from "./CompaniesBlock.vue?vue&type=script&lang=js&"
export * from "./CompaniesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports